import { Box, Paper, Stack, useMediaQuery, useTheme } from "@mui/material";

export default function PageWithFilter(props: {
    children?: JSX.Element | JSX.Element[];
    filter: JSX.Element;
}) {
    const theme = useTheme();
    const isMediumOrUp = useMediaQuery(theme.breakpoints.up("md"));

    return (
        <Box>
            <Stack direction="row">
                {isMediumOrUp && (
                    <Box
                        style={{
                            position: "fixed",
                            bottom: "15px",
                            top: "80px",
                            width: "330px",
                        }}
                    >
                        <Paper
                            sx={{
                                overflow: "hidden",
                                position: "relative",
                                height: "calc(100% - 2px)",
                            }}
                        >
                            <Box
                                sx={{
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    left: 0,
                                    bottom: 0,
                                }}
                            >
                                {props.filter}
                            </Box>
                        </Paper>
                    </Box>
                )}

                <Box sx={{ ml: { xs: 0, md: "350px" }, width: "100%" }}>
                    {props?.children}
                </Box>
            </Stack>
        </Box>
    );
}
